var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div'):_c('div',[_c('div',{staticClass:"title-post",staticStyle:{"min-height":"1.93rem"}},[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('recognitionHelp'),_c('voteRecognitionsList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }